import React, { useRef, useState } from "react";
import { CircularIndeterminate, FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import wellknown from "wellknown";
import { RNHZonaIns } from "services/services-mia/RNHZonaIns";

const wktPolygonSchema = yup.string()
    .required("Debe ingresar las coordenadas WKT")
    .test('valid-wkt-format', 'Formato de coordenadas inválido', function(value) {
        if (!value || !value.trim()) {
            return this.createError({ message: 'Ingrese las coordenadas' });
        }
        const wktString = `POLYGON((${value.trim()}))`;
        const parsed = wellknown.parse(wktString);
        
        if (!parsed) {
            return this.createError({ 
                message: 'El formato de las coordenadas no es válido'
            });
        }
        if (parsed.type !== 'Polygon') {
            return this.createError({ 
                message: 'Las coordenadas no forman un polígono válido'
            });
        }
        const coords = parsed.coordinates[0];
        if (coords.length < 4) {
            return this.createError({ 
                message: `Se requieren mínimo 4 coordenadas. Tienes ${coords.length - 1}.`
            });
        }
        return true;
    });

export default function InsertModal({ updateList, closeModal }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);
    const formikRef = useRef();

    const handleCreateZona = async (values) => {
        const response = await RNHZonaIns(
            credentials,
            { 
                name: values.nombre, 
                cod: values.cod,
                wkt: values.wkt
            }
        );
        if (response.length === 0) {
            setSnackBarInfo({
                message: "Zona creada correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            closeModal();
        }
    }
    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                nombre: "",
                cod: "",
                wkt: ""
            }}
            validationSchema={
                yup.object({
                    nombre: yup.string("Debe ingresar un nombre").max(45, "Debe tener menos de 45 caracteres").required("Debe ingresar un nombre"),
                    cod: yup.string("Debe ingresar un código").max(20, "Debe tener menos de 20 caracteres").required("Debe ingresar un código"),
                    wkt: wktPolygonSchema,
                })
            }
            onSubmit={(values) => {
                handleCreateZona(values);
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <>
                        <FormikTextInput
                            fullWidth={true}
                            name="nombre"
                            placeholder=""
                            labelText="Nombre de zona"
                        />
                        <FormikTextInput
                            fullWidth={true}
                            name="cod"
                            placeholder=""
                            labelText="Código de zona"
                        />
                        <FormikTextInput
                            fullWidth={true}
                            name="wkt"
                            placeholder="-58.362014 -34.618235, -58.361456 -34.621254, ..."
                            labelText="wkt"
                            multiline
                        />
                    </>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Crear" }}
                        onCloseModal={closeModal}
                    />
                    {(inRequest) && <CircularIndeterminate />}
                </div>
            </Form>
        </Formik>
    );
}
